module.exports = __webpack_public_path__ + "static/media/supplies_ordered.d96958bd.jpg";